import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import Main from "../components/layout/Main";
import routes from "./routes";
import _ from "lodash";
const AuthenticatedRoute = (props) => {
  const { title, component: C, props: childProps, ...rest } = props;
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    document.title = title;
  }, [title]);

  const rawPermission = useSelector(
    (state) => state?.auth?.user?.role?.permission?.permission
  );
  const permissions = rawPermission
    ? JSON.parse(rawPermission).strPermission
    : [];
  // console.log("permissions", permissions)
  const newRoutes = routes.filter((route) => {
    //first show all the ones without permission id
    if (!route.permissionId) return true;

    const rPermissionId = route.permissionId;
    //get the first layer of permission
    const findPermissionObj = _.find(permissions, { id: rPermissionId });
    // console.log('findPermissionObj', rPermissionId, findPermissionObj)
    if (findPermissionObj) {
      return findPermissionObj.state === 1;
    } else {
      //do the loop here for the second layer
      const findParentObj = _.find(permissions, {
        children: [
          {
            id: rPermissionId,
          },
        ],
      });

      // console.log("findPermissionChildObj", findParentObj)

      if (findParentObj) {
        const { children } = findParentObj;
        const childObj = _.find(children, { id: rPermissionId });

        return childObj.state === 1;
      }
    }

    return false;
  });

  // console.log("finalRoutes", newRoutes)

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return isLoggedIn ? (
          <>
            {_.find(newRoutes, { path: routeProps.match.path }) ? (
              <Main>
                <C {...routeProps} {...childProps} />
              </Main>
            ) : (
              <Redirect to={`/login?redirect=/`} />
            )}
          </>
        ) : (
          <Redirect
            to={`/login?redirect=${routeProps.location.pathname}${routeProps.location.search}`}
          />
        );
      }}
    />
  );
};

export default AuthenticatedRoute;
